import { OBJECT_READ_PARAMETERS, OBJECT_UPDATE_PARAMS } from '@isyc-react/oc-api/queries/parameter';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { getParameters, setParameters } from './data';
export default [
    {
        request: {
            query: OBJECT_READ_PARAMETERS,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: (variables) => {
            return {
                data: {
                    object_readParameters: getParameters(variables === null || variables === void 0 ? void 0 : variables.id)
                        .map((p) => (Object.assign(Object.assign({}, p), { __typename: 'ParameterDto' }))),
                },
            };
        },
    },
    {
        request: {
            query: OBJECT_UPDATE_PARAMS,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: (variables) => {
            const parameters = getParameters(variables === null || variables === void 0 ? void 0 : variables.id);
            setParameters(variables === null || variables === void 0 ? void 0 : variables.id, parameters);
            return {
                data: {
                    object_updateParameters: parameters.map((p) => (Object.assign(Object.assign({}, p), { __typename: 'ParameterDto' }))),
                },
            };
        },
    },
];
